import server from "utils/server";

export type MolliePage = "connect" | "dashboard";

export async function getMollieNavigationUrl(
    restaurantId: string,
    page: MolliePage
): Promise<string> {
    const id = encodeURIComponent(restaurantId);
    const path =
        page === "connect"
            ? `/v03/mollie/connectWithMollie/${id}`
            : `/v03/mollie/organization/${id}/dashboard`;
    const { data }: { data: { url?: unknown } | null } = await server.get(path, {
        headers: { Accept: "application/json" },
        ...(page === "connect" ? { withCredentials: true } : {})
    });
    if (typeof data?.url !== "string") {
        throw new Error("Missing Mollie destination");
    }
    const url = new URL(data.url);
    if (
        url.protocol !== "https:" ||
        !!url.username ||
        !!url.password ||
        (url.hostname !== "mollie.com" && !url.hostname.endsWith(".mollie.com"))
    ) {
        throw new Error("Invalid Mollie destination");
    }
    return url.href;
}

export async function openMolliePage(
    restaurantId: string,
    page: MolliePage,
    newTab = false
): Promise<void> {
    const popup = newTab ? window.open("about:blank", "_blank") : null;
    if (newTab && !popup) throw new Error("Popup blocked");
    if (popup) popup.opener = null;
    try {
        const url = await getMollieNavigationUrl(restaurantId, page);
        if (popup) popup.location.replace(url);
        else window.location.assign(url);
    } catch (error) {
        popup?.close();
        throw error;
    }
}
